import type { ComponentChildren } from "preact";
import { Icon } from "./Icon.tsx";

export interface AccordionItem { id: string; title: ComponentChildren; body: ComponentChildren }

/**
 * A list whose items open in place, such as an FAQ. Native `<details>`, so the
 * keyboard and find-in-page work, and any number can be open. An item's `id`
 * is its anchor, so a link can open it.
 */
export function Accordion({ label, items, open }: { label: string; items: ReadonlyArray<AccordionItem>; open?: string }) {
  return <div class="ui-accordion" role="group" aria-label={label}>
    {items.map((item) => <details key={item.id} id={item.id} class="ui-accordion__item" open={item.id === open}>
      <summary><span>{item.title}</span><Icon name="chevron" size={16} class="ui-accordion__chevron" /></summary>
      <div class="ui-accordion__body">{item.body}</div>
    </details>)}
  </div>;
}
